<template>
 
  <router-view/>
</template>
<style>
  @import '@/assets/index.css';
  </style>


